import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UmbracoImage } from '@models/umbraco.model';
import { CropModes } from '@shared/image/image.config';
import { ImageScalePipe } from '@shared/image/image-scale/image-scale.pipe';
import { IntersectionLazyImageDirective } from '../../intersection/intersection-lazy-image/intersection-lazy-image.directive';
import { NgClass, NgStyle, NgIf } from '@angular/common';

export type ImageVariant = 'gray-tint' | 'white-background';
export type Preset = '94|94' | '150|150' | '400|400' | '800|800';

// Product image query params has to fit one of these width/height presets or else it won't work:
// 94|94, 150|150, 400|400, 800|800, 0|150:350:400:560:800:820:1200:1600

@Component({
    selector: 'app-product-image',
    templateUrl: './product-image.component.html',
    styleUrls: ['./product-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgStyle, NgIf, IntersectionLazyImageDirective, ImageScalePipe]
})
export class ProductImageComponent {
    public srcWidth = 400;
    public srcHeight = 400;
    public srcWidth2x = 800;
    public srcHeight2x = 800;

    @Input()
    public readonly variant: ImageVariant = 'gray-tint';

    @Input()
    public readonly image: UmbracoImage;

    @Input()
    public readonly width: number = 400;

    @Input()
    public readonly height: number = 400;

    @Input()
    public set preset(value: Preset) {
        const [width, height] = value.split('|');
        this.srcWidth = Number(width);
        this.srcHeight = Number(height);
    }

    @Input()
    public set preset2x(value: Preset) {
        const [width, height] = value.split('|');
        this.srcWidth2x = Number(width);
        this.srcHeight2x = Number(height);
    }

    @Input()
    public readonly cropMode: CropModes = 'min';

    @Input()
    public wrapperWidth: string;

    @Input()
    public wrapperHeight: string;

    @Input()
    public index?: number;

    @Input()
    public indexLoadingThreshold: number = 4;
}
